import { render, staticRenderFns } from "./orderPushSets.vue?vue&type=template&id=2f591e3b&scoped=true&"
import script from "./orderPushSets.vue?vue&type=script&lang=js&"
export * from "./orderPushSets.vue?vue&type=script&lang=js&"
import style0 from "./orderPushSets.vue?vue&type=style&index=0&id=2f591e3b&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2f591e3b",
  null
  
)

component.options.__file = "orderPushSets.vue"
export default component.exports